import { render, staticRenderFns } from "./doublePlate.vue?vue&type=template&id=63bf88e3&"
import script from "./doublePlate.vue?vue&type=script&lang=js&"
export * from "./doublePlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports